// extracted by mini-css-extract-plugin
export default {"item":"Item_item__5TRdh","link":"Item_link__UiDcE","title":"Item_title__iPLzt","preview":"Item_preview__FSV0z","content":"Item_content__VG6GA","close":"Item_close__K71+f"};